import styled, { keyframes } from "styled-components";

const dotPulse = keyframes`
  0%, 80%, 100% {
    transform: scale(0.6);
    opacity: 0.4;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
`;

export const LoadingDots = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 10px;

  span {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background-color: var(--color-latex30);
    display: inline-block;
    animation: ${dotPulse} 1.2s infinite ease-in-out both;
  }

  span:nth-child(1) {
    animation-delay: -0.32s;
  }
  span:nth-child(2) {
    animation-delay: -0.16s;
  }
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

export const QrContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  .mercadoPago-img-QR {
    width: 280px;
    height: 280px;
    object-fit: contain;
  }
  .mercadoPago-right {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }
`;

export const BtnVolver = styled.button`
  border: 2px solid var(--color-latex30);
`;

export const Total = styled.div`
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  gap: 6px;
`;

const expand = keyframes`
  0% {
    clip-path: circle(0% at 50% 50%);
  }
  100% {
    clip-path: circle(150% at 50% 50%);
  }
`;

const pop = keyframes`
  0% {
    transform: scale(0);
    opacity: 0;
  }
  70% {
    transform: scale(1.15);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

export const SuccessOverlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: var(--color-broccoli);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: ${expand} 0.6s ease-out forwards;
`;

export const TildeWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 180px;
  height: 180px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.15);
  animation: ${pop} 0.5s 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) both;

  svg {
    width: 100px;
    height: 100px;
  }
`;
